export default "__VITE_ASSET__21280816__"